module.exports = __webpack_public_path__ + "media/assets/icons/min_infonoid_logo_white-9fe5f5631c64b2e4d1a0712c90941804.svg";